import { render, staticRenderFns } from "./ChooseStorehouse.vue?vue&type=template&id=9caa6dd6&scoped=true&"
import script from "./ChooseStorehouse.vue?vue&type=script&lang=js&"
export * from "./ChooseStorehouse.vue?vue&type=script&lang=js&"
import style0 from "./ChooseStorehouse.vue?vue&type=style&index=0&id=9caa6dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caa6dd6",
  null
  
)

export default component.exports